import React, { PureComponent } from 'react';
import {
  bool,
  element,
  node,
  string,
  func,
  number,
  oneOfType,
} from 'prop-types';
import styled from 'styled-components';

import ColorContext from 'context/color';

export const InputWrapper = styled.div`
  position: relative;
  background: #ededed;
`;
const Textarea = styled.textarea`
  -webkit-appearance: none;
  border: none;
  padding: ${(props) =>
      props.labelHeight ? `${props.labelHeight + 10}px` : '1.5em'}
    0.5em 0.5em;
  width: 100%;
  margin-bottom: 1em;
  border-bottom: 4px solid ${(props) => props.borderColor};
  outline: none;
  font-size: 1.25em;
  background: #ededed;
  transition: all 0.125s ease-in-out;
  :invalid {
    border-color: ${(props) =>
      !!props.value ? props.invalidColor : props.borderColor};
  }
  :invalid + span {
    color: ${(props) =>
      !!props.value
        ? props.invalidColor
        : props.active
        ? props.activeColor
        : '#ccc'};
  }
`;
const InputLabel = styled.span`
  position: absolute;
  top: 0;
  padding-top: 0.5rem;
  padding-left: 0.65rem;
  width: 100%;
  background: #ededed;

  font-weight: 400;
  font-size: ${(props) => (props.active ? '.75em' : '18px')};
  transform: translateY(${(props) => (props.active ? '0' : '.75rem')});
  transition: all 0.125s ease-in-out;
  color: ${(props) => (props.active ? props.activeColor : '#595959')};
  will-change: color, font-weight, transform, font-size;
`;

class InputTextarea extends PureComponent {
  static propTypes = {
    component: node,
    as: element,
    label: string,
    onChange: func,
    onBlur: func,
    delayInput: bool,
    required: bool,
    type: string,
    value: oneOfType([string, number]),
  };

  state = {
    focus: false,
    value: '',
    loading: false,
    labelRef: null,
  };

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  delayChange = () => {
    clearTimeout(this.searchtimeout);
    this.searchtimeout = setTimeout(
      () =>
        this.props.onChange({
          target: {
            name: this.props.name,
            value: this.state.value,
          },
        }),
      500
    );
  };

  handleChange = (e) => {
    e.preventDefault();
    if (this.props.delayInput) {
      if (this.inputRef.current.checkValidity()) {
        try {
          this.setState(
            { value: e.target.value, isDirty: true },
            this.delayChange
          );
        } catch (err) {
          console.error(err);
        }
      } else {
        this.inputRef.current.reportValidity();
      }
    } else {
      this.props.onChange(e);
    }
    this.setState({
      value: e.target.value,
      isDirty: true,
    });
  };

  setFocus = () => {
    this.inputRef.current.focus();
  };

  render() {
    const {
      component: Component = InputWrapper,
      as = Textarea,
      label,
      value,
      ...props
    } = this.props;

    const tValue =
      this.state.value ||
      (!this.state.isDirty ? value : '') ||
      props.defaultValue;

    return (
      <ColorContext.Consumer>
        {(colors) => (
          <Component>
            <Textarea
              value={tValue}
              type={this.props.type || 'text'}
              name={this.props.name}
              pattern={this.props.pattern}
              onChange={this.handleChange}
              onFocus={() => this.setState({ focus: true })}
              active={this.state.focus || tValue}
              borderColor={colors.tertiary}
              invalidColor={colors.auxilary_5}
              ref={this.inputRef}
              as={as}
              required={this.props.required}
              labelHeight={this.labelRef?.clientHeight}
            />
            <InputLabel
              ref={(ref) => {
                this.labelRef = ref;
                !this.state.labelRef && this.setState({ labelRef: ref });
              }}
              activeColor={colors.tertiary}
              active={
                this.state.focus ||
                ['date', 'file'].includes(props.type) ||
                tValue
              }
              onClick={this.setFocus}
            >
              {label}
            </InputLabel>
          </Component>
        )}
      </ColorContext.Consumer>
    );
  }
}

export default InputTextarea;
